<script setup>
	import { computed } from 'vue';
	import { DsIconButton } from '@coloplast/design-system';
	import { useStore } from 'vuex';

	const store = useStore();

	const setActiveHighlight = (payload) => store.commit('setActiveHighlight', payload);
	const activeHighlight = computed(() => store.getters['getActiveHighlight']);
	const hotspotIndex = computed(() => activeHighlight.value - 1);

	const props = defineProps({
		item: {
			type: Object,
			default: () => {},
		},
		ordinalNumber: {
			type: Number,
			required: true,
		},
	});

	const emit = defineEmits(['selectHotspot']);

	const selectSpot = () => {
		setActiveHighlight(props.ordinalNumber);
		emit('selectHotspot');
	};
</script>

<template>
	<Transition
		name="highlight"
		appear
	>
		<div
			v-show="true"
			class="c-product-hotspot c-product-hotspot--mobile"
		>
			<DsIconButton
				aria-label="Show information box"
				icon-name="add"
				variant="secondary"
				size="sm"
				class="c-product-hotspot__button c-product-hotspot__button--mobile"
				:class="{
					'c-product-hotspot__button--mobile-selected': ordinalNumber === activeHighlight,
				}"
				@click="selectSpot"
				data-testid="hotspot-mobile"
			/>
			<div class="c-product-hotspot__button-area c-product-hotspot__button-area--mobile"></div>
		</div>
	</Transition>
</template>
